import {AxiosError} from 'axios';
import {useMutation, UseMutationOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';

import {useMembersQuery, useUsersQuery} from './';
import {useFetchGroup} from './useGroupQuery';

interface Params {
  memberID: number;
}

export function useDeleteMemberMutation(
  groupID: string | number,
  options?: UseMutationOptions<unknown, AxiosError, Params>,
) {
  const fetchGroup = useFetchGroup(groupID);
  const usersQuery = useUsersQuery({skipGroup: groupID, q: ''});
  const membersQuery = useMembersQuery({groupId: groupID, q: ''});

  return useMutation<unknown, AxiosError, Params>(
    ({memberID}) => api.delete(`v2/groups/members/${groupID}/${memberID}`),
    {
      ...options,
      onSuccess: (...params) => {
        options?.onSuccess?.(...params);
        Promise.all([fetchGroup(), usersQuery.refetch(), membersQuery.refetch()]);
      },
    },
  );
}
